import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Popover from '@material-ui/core/Popover'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import { Plus, Search } from 'lucide-react'
import i18n from '../../../assets/i18n'
import { tokens } from '../../../assets/tokens'
import { AddTagButton, TagsMenu } from './styled'

// Botón «Añadir» que abre un popover con buscador y la lista de etiquetas disponibles.
// Sustituye al Select con un Autocomplete dentro, que se abría a destiempo y descolocaba la ficha.
const SelectTags = ({ onChange, options, labelSelectorStatus, loading = false }) => {
  const anchorRef = useRef(null)
  const [localOpen, setLocalOpen] = useState(false)
  const [search, setSearch] = useState('')

  const open = labelSelectorStatus ? !!labelSelectorStatus.isLabelSelectorOpened : localOpen
  const setOpen = value => {
    if (labelSelectorStatus) labelSelectorStatus.setIsLabelSelectorOpened(value)
    else setLocalOpen(value)
  }

  const handleClose = () => {
    setOpen(false)
    setSearch('')
  }

  const handleSelect = option => {
    onChange(option)
    handleClose()
  }

  const term = search.trim().toLowerCase()
  const filteredOptions = (options || []).filter(option => (option.name || '').toLowerCase().includes(term))

  return (
    <>
      <AddTagButton type="button" ref={anchorRef} onClick={() => setOpen(true)} aria-haspopup="listbox" disabled={loading} aria-busy={loading}>
        {loading ? <CircularProgress size={12} thickness={5} color="inherit" /> : <Plus size={14} />}
        {i18n.modalChangeTags.add}
      </AddTagButton>
      <Popover
        open={open && !loading}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { marginTop: 4, borderRadius: 8, boxShadow: tokens.shadow.card } }}
      >
        <TagsMenu>
          <TextField
            autoFocus
            fullWidth
            variant="outlined"
            value={search}
            placeholder={i18n.modalChangeTags.search}
            onChange={e => setSearch(e.target.value)}
            onKeyDown={e => {
              e.stopPropagation()
              if (e.key === 'Enter' && filteredOptions.length === 1) handleSelect(filteredOptions[0])
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search size={16} color={tokens.color.text.tertiary} />
                </InputAdornment>
              )
            }}
          />
          <ul className="tags-list" role="listbox">
            {filteredOptions.length ? (
              filteredOptions.map(option => (
                <li key={option.id} role="option" aria-selected={false}>
                  <button type="button" onClick={() => handleSelect(option)}>
                    <span className="tag-dot" style={{ backgroundColor: option.color || tokens.color.border.default }} />
                    <span className="tag-name">{option.name}</span>
                  </button>
                </li>
              ))
            ) : (
              <li className="empty">{i18n.modalChangeTags.noOptions}</li>
            )}
          </ul>
        </TagsMenu>
      </Popover>
    </>
  )
}

SelectTags.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  labelSelectorStatus: PropTypes.shape({
    isLabelSelectorOpened: PropTypes.bool,
    setIsLabelSelectorOpened: PropTypes.func
  }),
  loading: PropTypes.bool
}

export default SelectTags
